import _ from "lodash";
import { TweenMax } from "gsap";

export default {
    namespaced: true,
    state: () => ({
        items: [],
        pin_item: null,
        moderators: [],
        my_room: null,
        is_bottom: true,
        is_new_item: false,
    }),
    actions: {
        SOCKET_onInitialLiveChat({ state, commit, dispatch }, res){
            console.log('SOCKET_onInitialLiveChat ->', res);
            commit('setItems', res.items);
            commit('setPinItem', res.pin_item);
            commit('setModerators', res.moderators);

            setTimeout(() => {
                dispatch('scroll', false);
            }, 300);
        },

        SOCKET_onGetLiveChatMessagesL({ commit, dispatch }, res){
            console.log('SOCKET_onGetLiveChatMessagesL ->', res);
            commit('setItems', res.items);
            dispatch('scroll', false);
        },

        SOCKET_onGlobalSendLiveChatMessage({ state, commit, dispatch }, res){
            if(res.item.room == state.my_room){
                console.log('SOCKET_onGlobalSendLiveChatMessage ->', res);
                commit('addItem', res.item);
                dispatch('scroll', true);
            }
        },

        SOCKET_onGetPinMessage({ state, commit, dispatch }, res){
            console.log('SOCKET_onGetPinMessage ->', res);
            if(res.item){
                commit('setPinItem', res.item);
            }
        },

        SOCKET_onSetPinMessage({ state, commit, dispatch }, res){
            if(res.item.room == state.my_room){
                console.log('SOCKET_onSetPinMessage ->', res);
                commit('setPinItem', res.item.message? res.item : null);
            }
        },

        SOCKET_onRemoveMessage({ state, commit }, res){
            if(res.item.room == state.my_room){
                console.log('SOCKET_onRemoveMessage ->', res);
                commit('removeItem', res.item);
            }
        },

        SOCKET_onEmptyLiveChat({ state, commit }, res){
            if(res.item == state.my_room){
                console.log('SOCKET_onEmptyLiveChat ->', res);
                commit('setItems', []);
                commit('setPinItem', null);
            }
        },
        
        SOCKET_onGetModerators({ state, commit }, res){
            console.log('SOCKET_onGetModerators ->', res);
            commit('setModerators', res.items);
        },

        scroll({ state, commit, rootState }, res){
            // if(!state.moderators.includes(rootState.auth.user? rootState.auth.user.hid : 'z_live_chat')){
            TweenMax.delayedCall(.1, () => {
                TweenMax.killTweensOf('#live_chat_content');
                var num =  $('#live_chat_content > div').height() + 80 - $('#live_chat_content').height();
                if(res == true){
                    if(state.is_bottom){
                        TweenMax.to(`#live_chat_content`, .3, { scrollTop: num });
                    }else{
                        commit('setIsNewItem', true);
                    }
                }else{
                    TweenMax.set(`#live_chat_content`, { scrollTop: num });
                }
            });
        },
    },
    mutations: {
        setItems(state, items){
            state.items = items;
        },
        addItem(state, item){
            if(state.items.length > 1000){
                state.items.splice(0, 500);
            }
            state.items.push(item);
        },
        setPinItem(state, item){
            state.pin_item = item;
        },
        removeItem(state, item){
            if(state.pin_item){
                if(item.hid == state.pin_item.hid){
                    state.pin_item = null;
                }
            }

            state.items = _.reject(state.items, { hid: item.hid });
        },

        setModerators(state, items){
            state.moderators = items;
        },
        setMyRoom(state, item){
            state.my_room = item;
            state.items = [];
            state.pin_item = null;
        },
        setIsBottom(state, item){
            state.is_bottom = item;
            if(item) state.is_new_item = false;
        },
        setIsNewItem(state, item){
            state.is_new_item = item;
        }
    }
}

